module.exports = __webpack_public_path__ + "static/minicrm-fb63e1607370c1da87912142a9cc6bac.png";